import { EnhancedPlan, FeatureCategory } from "../types";

// Default plans when API fails
export const fallbackPlans: EnhancedPlan[] = [
    {
        id: "free-plan",
        name: "Basic",
        description: "Start your interview preparation journey",
        price: 0,
        currency: "USD",
        interval: "",
        features: [
            "5 AI-powered mock interviews per month",
            "Access to 50+ interview questions",
            "Basic performance reports",
            "24/7 practice availability",
            "Industry-specific questions",
        ],
        productId: "sample-product-free",
    },
    {
        id: "plus-plan",
        name: "WeKruit Plus",
        description: "Perfect for serious interview preparation",
        price: 29.99,
        currency: "USD",
        interval: "month",
        features: [
            "Unlimited AI-powered mock interviews",
            "200+ interview questions",
            "2 live case interviews with MBB consultants",
            "Detailed performance reports",
            "Advanced answer analysis",
            "Priority support",
            "All Basic features included",
        ],
        highlighted: true,
        mostPopular: true,
        badge: "Recommended",
        productId: "wekruit-plus",
        trialPeriod: {
            intervalUnit: "DAY",
            intervalCount: 10,
            formatted: "10 days",
        },
    },
    {
        id: "pro-plan",
        name: "WeKruit Pro",
        description: "Best for consulting case interview prep",
        price: 59.99,
        currency: "USD",
        interval: "month",
        features: [
            "All Plus features included",
            "Personalized coaching sessions",
            "Interview strategy session",
            "Comprehensive performance reports",
            "Priority MBB consultant support",
            "Exclusive hiring opportunities",
        ],
        badge: "Best Value",
        productId: "wekruit-pro",
        trialPeriod: {
            intervalUnit: "DAY",
            intervalCount: 10,
            formatted: "10 days",
        },
    },
];

// Detailed feature comparison table
export const featureCategories: FeatureCategory[] = [
    {
        name: "Interview Practice",
        features: [
            {
                name: "AI-powered mock interviews",
                description:
                    "Practice with our AI interviewer that adapts to your responses",
                basic: "5 per month",
                plus: "Unlimited",
                pro: "Unlimited",
                competitors: "Limited",
            },
            // {
            //     name: "Question bank access",
            //     description: "Access to our database of interview questions",
            //     basic: "50+ questions",
            //     plus: "200+ questions",
            //     pro: "200+ questions",
            //     competitors: "Varies",
            // },
            {
                name: "Industry-specific questions",
                description:
                    "Questions tailored to specific industries and roles",
                basic: true,
                plus: true,
                pro: true,
                competitors: "Varies",
            },
        ],
    },
    {
        name: "Feedback & Analysis",
        features: [
            {
                name: "Performance reports",
                description: "Receive detailed reports after each session",
                basic: "Basic",
                plus: "Detailed",
                pro: "Comprehensive",
                competitors: "Limited",
            },
            {
                name: "Answer quality analysis",
                description: "AI-powered analysis of your answers",
                basic: "Basic",
                plus: "Advanced",
                pro: "Advanced",
                competitors: false,
            },
            {
                name: "Interview recordings",
                description: "Record and review your interviews",
                basic: true,
                plus: true,
                pro: true,
                competitors: "Varies",
            },
            {
                name: "Improvement tracking",
                description: "Track your progress over time",
                basic: true,
                plus: true,
                pro: true,
                competitors: false,
            },
        ],
    },
    {
        name: "Real MBB Interviewers",
        features: [
            {
                name: "Live case interviews",
                description:
                    "Real case interviews with experienced MBB consultants",
                basic: false,
                plus: "2 sessions",
                pro: "Included",
                competitors: "$$$ per hour",
            },
            {
                name: "Personalized coaching",
                description: "One-on-one coaching sessions with feedback",
                basic: false,
                plus: false,
                pro: "Included",
                competitors: "$$$ per hour",
            },
        ],
    },

    {
        name: "Additional Benefits",
        features: [
            {
                name: "Interview strategy session",
                description: "Session focused on overall interview strategy",
                basic: false,
                plus: false,
                pro: "Included",
                competitors: "$$$ extra",
            },
            {
                name: "Priority support",
                description: "Get faster responses from our support team",
                basic: false,
                plus: true,
                pro: true,
                competitors: "Varies",
            },
            {
                name: "24/7 Availability",
                description: "Practice whenever and wherever you want",
                basic: true,
                plus: true,
                pro: true,
                competitors: "Limited",
            },
            {
                name: "Hiring partner database",
                description: "Access to exclusive hiring opportunities",
                basic: false,
                plus: true,
                pro: true,
                competitors: false,
            },
        ],
    },
];

// Competitor comparison features
export const competitiveComparison = [
    {
        title: "Limited Availability",
        description:
            "Traditional coaches have limited availability and require scheduling",
        included: false,
        icon: "Calendar",
    },
    {
        title: "High Hourly Cost",
        description: "Typically $150-300 per hour for quality coaching",
        included: false,
        icon: "DollarSign",
    },
    {
        title: "Inconsistent Quality",
        description: "Quality varies widely between different coaches",
        included: false,
        icon: "Shuffle",
    },
    {
        title: "No Objective Tracking",
        description: "Lack of data-driven performance tracking",
        included: false,
        icon: "TrendingDown",
    },
];
